import React from 'react';
import { TopNav } from './TopNav';
import { BottomNav } from './BottomNav';
import { cn } from '@/lib/utils';

interface AppLayoutProps {
  children: React.ReactNode;
  showTopNav?: boolean;
  showBottomNav?: boolean;
  topNavConfig?: {
    title: string;
    leftAction?: { icon: string; action: string } | null;
    rightAction?: { icon: string; action: string } | null;
  };
  bottomNavTabs?: Array<{
    id: string;
    label: string;
    icon: string;
    href?: string;
    order?: number;
    badge?: number;
    active?: boolean;
  }>;
  backgroundColor?: 'default' | 'muted' | 'accent';
  className?: string;
  onNavAction?: (action: string) => void;
}

export function AppLayout({ 
  children, 
  showTopNav = true, 
  showBottomNav = true,
  topNavConfig,
  bottomNavTabs = [],
  backgroundColor = 'default',
  className,
  onNavAction
}: AppLayoutProps) {
  return (
    <div className={cn(
      "min-h-screen flex flex-col",
      backgroundColor === 'muted' && "bg-muted",
      backgroundColor === 'accent' && "bg-accent/5",
      backgroundColor === 'default' && "bg-background",
      className
    )}>
      {/* Top Navigation */}
      {showTopNav && topNavConfig && (
        <TopNav
          title={topNavConfig.title}
          leftAction={topNavConfig.leftAction}
          rightAction={topNavConfig.rightAction}
          onActionClick={onNavAction}
        />
      )}
      
      {/* Main Content */}
      <main className={cn(
        "flex-1 relative",
        showTopNav && "pt-14",
        showBottomNav && "pb-16"
      )}>
        {children}
      </main>
      
      {/* Bottom Navigation */}
      {showBottomNav && bottomNavTabs.length > 0 && (
        <BottomNav tabs={bottomNavTabs} />
      )}
    </div>
  );
}